import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import { getGrievanceRedressalContent, getAvailableLanguagesForGrievance } from '../utils/grievanceRedressalContent-i18n';
import { Globe } from 'lucide-react';

export default function GrievanceRedressalPage() {
    const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
    const grievanceEmail = process.env.REACT_APP_GRIEVANCE_EMAIL || 'grievance@eternallocker.com';
    const grievanceOfficerName = process.env.REACT_APP_GRIEVANCE_OFFICER_NAME || 'Y. R. Gandhi';
    const grievanceOfficerTitle = process.env.REACT_APP_GRIEVANCE_OFFICER_TITLE || 'Grievance Officer';

    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('language') || 'en';
    });

    const availableLanguages = getAvailableLanguagesForGrievance();
    const content = getGrievanceRedressalContent(language);

    const replacePlaceholders = (text) => {
        if (!text || typeof text !== 'string') return text;
        return text
            .replace('{{GRIEVANCE_OFFICER_NAME}}', grievanceOfficerName)
            .replace('{{GRIEVANCE_OFFICER_TITLE}}', grievanceOfficerTitle)
            .replace('{{GRIEVANCE_EMAIL}}', grievanceEmail);
    };

    useEffect(() => {
        document.title = language === 'en' ? 'Grievance Redressal | Eternal Locker™' : 'शिकायत निवारण | Eternal Locker™';
        localStorage.setItem('language', language);
    }, [language]);

    return (
        <>
            <Header type="small" showAccountDropdown={isLoggedIn} />
            <div className="flex justify-center w-full font-sans">
                <div className="w-full max-w-7xl p-8 space-y-6 bg-background-light shadow-2xl rounded-xl border border-accent-main">
                    {/* Language Selector */}
                    <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
                        <h1 className="text-3xl font-bold text-accent-main">{content.title}</h1>
                        <div className="flex items-center gap-2">
                            <Globe className="w-5 h-5 text-accent-main" />
                            <select 
                                value={language}
                                onChange={(e) => setLanguage(e.target.value)}
                                className="px-3 py-2 border border-accent-main rounded bg-background-light text-accent-main text-sm font-medium hover:bg-primary-light cursor-pointer"
                            >
                                {availableLanguages.map(lang => (
                                    <option key={lang} value={lang}>
                                        {lang === 'en' ? 'English' : lang === 'hi' ? 'हिंदी' : lang.toUpperCase()}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="flex flex-col gap-8 p-4 bg-primary-light border border-accent-main rounded-xl shadow">
                        <div className="text-lg text-justify">
                            <p>{content.intro}</p>
                        </div>

                        {Object.entries(content.sections).map(([key, section]) => (
                            <div key={key}>
                                <h2 className="text-2xl font-semibold text-accent-main">{section.title}</h2>
                                {Array.isArray(section.content) ? (
                                    <ul className="list-disc list-inside space-y-2 text-justify mt-3">
                                        {section.content.map((item, idx) => (
                                            <li key={idx}>{replacePlaceholders(item)}</li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-justify mt-3">{replacePlaceholders(section.content)}</p>
                                )}
                            </div>
                        ))}

                        <div className="text-sm text-right text-gray-400">
                            <p>{language === 'en' ? 'Last updated: April 2, 2026' : 'अंतिम अपडेट: 2 अप्रैल, 2026'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
